import OrderCURModule from "@/modules/OrderCUR";

function ViewOrderPage() {
  return <OrderCURModule type="view" />;
}

export default ViewOrderPage;
